export default __webpack_public_path__ + "static/media/rb.f5bc48a7.png";